
import { useToast } from "@/hooks/use-toast";

interface Customer {
  id: string;
  name: string;
  email: string;
  phone: string;
  totalSpent: string;
  purchases: number;
  [key: string]: any;
}

export function useCustomerExport() {
  const { toast } = useToast();

  const exportCustomers = (customers: Customer[], format: 'txt' | 'csv' | 'xlsx') => {
    // Create the export data
    let content = '';
    
    // Header row
    content = 'Nome,Email,Telefone,Compras,Total Gasto\n';
    
    // Add rows for each filtered customer
    customers.forEach(customer => {
      content += `${customer.name},${customer.email},${customer.phone},${customer.purchases},${customer.totalSpent}\n`;
    });
    
    // Create and trigger download based on format
    const blob = new Blob([content], { type: `text/${format === 'xlsx' ? 'xlsx' : format}` });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `clientes.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    toast({
      title: "Exportação concluída",
      description: `Os dados foram exportados no formato ${format.toUpperCase()}`,
    });
  };

  return { exportCustomers };
}
